import { useState } from "react";
import type { AssignmentMode } from "../components/UserManagement/AccessSelector";

type InitialAccessState = {
  mode?: AssignmentMode;
  groupId?: number | null;
  airlineIds?: number[];
  singleAirlineId?: number | null;
};

export const useAccessSelectorState = ({
  mode: initialMode = "group",
  groupId: initialGroupId = null,
  airlineIds: initialAirlineIds = [],
  singleAirlineId: initialSingleAirlineId = null,
}: InitialAccessState = {}) => {
  const [mode, setMode] = useState<AssignmentMode>(initialMode);
  const [selectedGroupId, setSelectedGroupId] = useState<number | null>(initialGroupId);
  const [selectedAirlineIds, setSelectedAirlineIds] = useState<number[]>(initialAirlineIds);
  const [selectedSingleAirlineId, setSelectedSingleAirlineId] = useState<number | null>(initialSingleAirlineId);

  const onGroupChange = (id: number | null) => {
    setSelectedGroupId(id);
    setSelectedAirlineIds([]);
  };

  const onAirlineToggle = (airlineId: number) => {
    setSelectedAirlineIds((prev) =>
      prev.includes(airlineId) ? prev.filter((id) => id !== airlineId) : [...prev, airlineId],
    );
  };

  const isAccessValid =
    (mode === "group" && selectedGroupId !== null && selectedAirlineIds.length > 0) ||
    (mode === "single" && selectedSingleAirlineId !== null);

  return {
    mode,
    setMode,
    selectedGroupId,
    selectedAirlineIds,
    selectedSingleAirlineId,
    onGroupChange,
    onAirlineToggle,
    onSingleAirlineChange: setSelectedSingleAirlineId,
    isAccessValid,
  };
};
